<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!--title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["eventEdition"] }} </h4>
        </div>        
  
        <!-- body -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0" :model="event" ref="formEvent" :rules="rules">
            <div class="gridTemplate">
  
                <!-- Event Name -->    
                <el-form-item :label="i18nValues['name']" prop="name"> 
                  <el-input v-model="event.name" maxlength="30"></el-input>
                </el-form-item>      

                <!-- Event Detailed Trait -->    
                <el-form-item :label="i18nValues['detailedTrait']" prop="detailedTrait"> 
                  <el-input v-model="event.detailedTrait"></el-input>
                </el-form-item>     
  
            </div>          
          </el-form>
  
          <!-- CANCEL/SAVE --> 
          <div class="full-width d-flex justify-content-end mt-2">
            <el-button :loading="loading" size="small" @click="cancel()">
              {{ i18nValues["cancel"] }}
            </el-button>
            <el-button v-if="!isReadOnly()" icon="fas fa-check" :loading="loading" size="small" class="btn-primary" @click="save()">
              {{ i18nValues["save"] }}
            </el-button>
          </div>  
  
        </div>      
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  export default {
    name: "EventEdition",  
  
    created(){
  
      if(this.id != 0 ){
          this.retrieveById();
      } else{
          this.event.creationUser = this.user.name;
          this.event.creationDate = new Date();
      }
  
      this.rules= {
        name:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
      };

    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };
  
    },
  
    components: {
      
    },
  
    computed: {
      loading: get("customer/loading"),
    },
  
    props:["id"],
  
    data() {
      return {
  
        event: {
          name: null,
        },
  
      rules:{},
      returnQuery: {},
  
      };
    },
  
    methods: {
      save(){
        this.$refs["formEvent"].validate(valid => {
          if(valid){
            this.$store.dispatch("event/saveEvent", this.event).then((res) =>{            
              if(res.status == "OK"){
                  this.$notify.success({
                      title: this.i18nValues["succes"],
                      message: this.i18nValues["eventSaved"],
                      position: "bottom-right",
                  });      
                  this.$router.push({name:"EventAdmin", query: this.returnQuery});    
              } else {
                  this.$notify.error({
                      title: this.i18nValues["error"],
                      message: this.i18nValues["eventSaveError"],
                      position: "bottom-right",
                  });
              }           
            });
          }
        });
      },
  
      cancel(){
          this.$router.push({name:"EventAdmin", query: this.returnQuery});
      },
  
      retrieveById(){
          this.$store.dispatch("event/retrieveEventById", { id: this.id }).then((res)=>{
              this.event = res;
              this.event.modificationUser = this.user.name;
              this.event.modificationDate = new Date();
          });       
      },
    },
  
  
  }
  </script>
  
  <style>
  
  </style>